import { useContext } from "react";

import Link from "@mui/material/Link";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import typography from "assets/theme/base/typography";

import { LanguageContext } from "context";

// Declaring props types for Footer
interface Props {
  company?: {
    href: string;
    name: string;
  };
  links?: {
    href: string;
    name: string;
  }[];
  [key: string]: any;
}

const defaultCompany = { href: "https://smart-beast-soft.com/", name: "Smart Beast Software" };
const defaultLinks = [
  { href: "https://chronospark.jp/privacy/", name: "footer.privacy" },
  { href: "https://chronospark.jp/terms/", name: "footer.terms" },
  { href: "https://chronospark.jp/help/", name: "footer.help" },
  { href: "https://chronospark.jp/support/", name: "footer.contact" },
];

function Footer({ company = defaultCompany, links = defaultLinks }: Props): JSX.Element {
  const { href, name } = company;
  const { size } = typography;
  const { t } = useContext(LanguageContext) || { t: (k: string) => k };

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text">
            {t(link.name)}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}, {t("footer.made_by")}
        <Link href={href} target="_blank">
          <MDTypography variant="button" fontWeight="medium">
            &nbsp;{name}&nbsp;
          </MDTypography>
        </Link>
        {t("footer.for_a_better_web")}
      </MDBox>
      <MDBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,
          pr: 8,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

export default Footer;
